import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import utils from '../../utils';
import { PLATFORM } from '../../constants';
var Abzorba = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Abzorba(args) {
    var _this;
    _classCallCheck(this, Abzorba);
    _this = _callSuper(this, Abzorba, [args]);
    /**
     * Abzorba Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    _this.jsonParserEvent = function (payload) {
      var soundEffects = store.getState().playerInfo.soundEffects;
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;
      if (soundEffects !== _this.currentSoundSetting) {
        _this.setSound();
      }
      switch (payload.event) {
        case 'load_completed':
          _this.sendAnalyticEvent();
          _this._gameReady();
          _this.setSound();
          break;
        case 'round_result':
          if (payload.bet) {
            _this._currentBet = parseInt(payload.bet);
            _this.AddSpinXP(payload.bet);
            _this.DebitCoins(payload.bet);
            if (payload.playerBalance) _this.syncCoinsBalance(payload.playerBalance);
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              gameId: gameId,
              amount: _this._currentBet
            }));
            if (payload.won && payload.won > 0) {
              _this.CreditCoins(payload.won);
              var win = parseInt(payload.won);
              store.dispatch(setSpinEvent({
                playerId: playerId,
                createdTimestamp: Date.now(),
                spinPhase: SPIN_PHASE.WIN,
                gameId: gameId,
                amount: win
              }));
              if (parseInt(payload.won) >= 10 * _this._currentBet && !utils.isWebOrMobileWeb()) _this.showRateUsScreen();
            }
          }
          break;
        case 'out_of_coins':
          {
            _this._outOfCoins();
            _this.showOutOfCoinsScreen();
            break;
          }
        case 'error':
          {
            var errorDescription = JSON.stringify(payload);
            _this.sendErrorCreatedEvent(errorDescription);
            break;
          }
        default:
          break;
      }
    };
    _this._currentBet = 0;
    _this.currentSoundSetting = false;
    return _this;
  }
  _inherits(Abzorba, _GameInterface);
  return _createClass(Abzorba, [{
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent(JSON.stringify({
        name: soundEffects ? 'unmuteAll' : 'muteAll'
      }));
      this.currentSoundSetting = soundEffects;
    }
  }]);
}(GameInterface);
export default Abzorba;